export default {
      id: "icon-timer-usage",
      viewBox: "0 0 125 104",
      url: __webpack_public_path__ + "icons.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }